module.exports = {
	"name": "Intramural Sports Building",
	"bathroomrating": [],
	"tips": [],
	"address": "606 E Hoover Ave, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://magnify.michigandaily.us/best_of_ann_arbor_2017/images/sam.BOAA.IMBuilding.3.30.17.017.jpg",
			"caption": "",
			"author": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160412/eaa.online_1.jpg?itok=XUdq_rkN",
			"caption": "DJ Scout performs at VictorThon 2016 in the intramural sports building on March 12, 2016.",
			"author": "Evan Aaron"
		}
	],
	"position": {
		"lat": 42.269461,
		"lng": -83.742503
	},
	"catImage": "orangestar.png",
	"totalCats": 2,
	"totalMisc": 1,
	"categories": {
		"location": 1,
		"recarea": 1,
		"fitnesscenter": 1,
		"pickupsports": 1,
		"bestofaa": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/imbuilding.json
// module id = 894
// module chunks = 0